<fullscreen-page>
    <content-column>
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden pt-3" slot="content">

            <div class="d-flex flex-column flex-fill min-vh-0">
                <div class="d-flex flex-row flex-fill gap-3 min-vh-0">
                    <div class="flex-grow-1 min-vh-0 overflow-auto tab-panel-wrap" style="flex-basis: 66.666%;">
                        <dx-tab-panel
                            [animationEnabled]="true"
                            [swipeEnabled]="false"
                            iconPosition="start"
                            stylingMode="primary"
                            width="100%">

                            <dxi-item [title]="'Kataloge in Preparation' | translate" icon="edit">
                                <div class="mt-2">
                                    <div class="catalog-list">
                                        <dx-list
                                            class="catalog-dx-list"
                                            [dataSource]="preparationCatalogs"
                                            [searchEnabled]="true"
                                            searchExpr="name"
                                            searchMode="contains"
                                            [searchEditorOptions]="searchEditorOptions"
                                            [selectionMode]="'single'"
                                            [selectedItemKeys]="selectedCatalogId ? [selectedCatalogId] : []"
                                            keyExpr="id"
                                            (onItemClick)="onCatalogRowClick($event.itemData.id)"
                                        >
                                            <div *dxTemplate="let catalog of 'item'">
                                                <div class="catalog-row catalog-row--muted"
                                                     [class.catalog-row--selected]="selectedCatalogId === catalog.id"
                                                     (dblclick)="onOpenCatalogClicked(catalog.id)">
                                                    <div class="catalog-row__drag">
                                                        <i class="dx-icon-menu"></i>
                                                    </div>

                                                    <div class="catalog-row__main">
                                                        <div class="catalog-row__title">{{ catalog.name }}</div>
                                                    </div>

                                                    <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                                        <dx-button
                                                            icon="export"
                                                            stylingMode="text"
                                                            type="default"
                                                            [hint]="'Katalog öffnen' | translate"
                                                            (onClick)="onOpenCatalogClicked(catalog.id)">
                                                        </dx-button>
                                                        <dx-button
                                                            icon="overflow"
                                                            stylingMode="text"
                                                            type="default"
                                                            (onClick)="openPreparationRowMenu($event)">
                                                        </dx-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-list>
                                    </div>
                                </div>
                            </dxi-item>

                            <dxi-item [title]="'Archiv' | translate" icon="floppy">
                                <div class="mt-2">
                                    <div class="catalog-list">
                                        <dx-list
                                            class="catalog-dx-list"
                                            [dataSource]="archivCatalogs"
                                            [searchEnabled]="true"
                                            searchExpr="name"
                                            searchMode="contains"
                                            [searchEditorOptions]="searchEditorOptionsArchive"
                                            [selectionMode]="'single'"
                                            keyExpr="id"
                                            [selectedItemKeys]="selectedCatalogId ? [selectedCatalogId] : []"
                                            (onItemClick)="onCatalogRowClick($event.itemData.id)"
                                        >
                                            <div *dxTemplate="let catalog of 'item'">
                                                <div
                                                    class="catalog-row catalog-row--muted"
                                                    [class.catalog-row--selected]="selectedCatalogId === catalog.id"
                                                    (dblclick)="onOpenCatalogClicked(catalog.id)"
                                                >
                                                    <div class="catalog-row__drag">
                                                        <i class="dx-icon-menu"></i>
                                                    </div>

                                                    <div class="catalog-row__main">
                                                        <div class="catalog-row__title">{{ catalog.name }}</div>
                                                    </div>

                                                    <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                                        <dx-button
                                                            icon="export"
                                                            stylingMode="text"
                                                            type="default"
                                                            [hint]="'Katalog öffnen' | translate"
                                                            (onClick)="onOpenCatalogClicked(catalog.id)">
                                                        </dx-button>
                                                        <dx-button
                                                            icon="overflow"
                                                            stylingMode="text"
                                                            type="default"
                                                            (onClick)="openArchiveRowMenu($event)"
                                                        >
                                                        </dx-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-list>
                                    </div>
                                </div>
                            </dxi-item>
                        </dx-tab-panel>
                        <dx-context-menu
                            #rowMenu
                            [dataSource]="rowMenuItems"
                            [width]="200"
                            [showEvent]="''"
                            [position]="{ my: 'left top', at: 'left bottom' }"
                            (onItemClick)="onMenuItemClick($event)">
                        </dx-context-menu>
                    </div>

                    <div class="min-vh-0 overflow-auto prepare-stage-inspector" style="flex-basis: 33.333%;">
                        <np-inspect-container-catalog
                            [container]="container"
                            [catalogId]="selectedCatalogId"
                            [showContainerTab]="false"
                            (containerSaved)="containerSaved.emit($event)">
                        </np-inspect-container-catalog>
                    </div>
                </div>

            </div>
        </div>
    </content-column>
</fullscreen-page>
